import Api from "./api";

export default class ReadingsApi extends Api {
	constructor(token, clientId, onUnathourized) {
		super(token, clientId, onUnathourized);
		this.baseUrl = this.getBaseUrl() + "readings/";
	}

	getLatestReadings(facility, onSuccess, onError) {
		let endPoint =
			this.baseUrl + `latest/?facility=${facility.split("/").slice(-2)[0]}`;
		this.Get(endPoint, onSuccess, onError);
	}

	getTrends(
		facility,
		fromDate,
		toDate,
		onSuccess,
		onError,
		aggType,
		keys,  // javascript object
		controllers,  // list
		locations,  // list
		systems,  // list 
		names, // list
		tariffs // list
	) {
		
		const endPoint = this.baseUrl + "trends/";

		let data = {
			facility: facility.split("/").slice(-2)[0],
			from_date: fromDate.toISOString().split("T")[0],
			to_date: toDate.toISOString().split("T")[0],
			time_agg: aggType,
			keys: [],
			data_agg: {},
			power_agg: {}
		};



		for (const [key, value] of Object.entries(keys)) {

			if (value) {
				data.keys.push(key)
				if (["average_by_location", "kwh_by_location"].includes(value)){
					data.data_agg[key] = "location"
				} else if (["average_by_system", "kwh_by_system"].includes(value)){
					data.data_agg[key] = "system"
				} else if (value === "average") {
					data.data_agg[key] = "all"
				}

				if (["kwh_by_location",  "kwh_by_system"].includes(value)){
					data.power_agg[key] = "kWh"
				}

			}
				
		  }
		
		if (controllers.length > 0)
			data["controller"] = controllers
		if (locations.length > 0)
			data["location"] = locations
		if (systems.length > 0)
			data["system"] = systems
		if (names.length > 0)
			data["name"] = names
		if (tariffs.length > 0)
			data["tariff"] = tariffs

		this.Post(endPoint, data, onSuccess, onError);
	}

	getTrendsExcel(facility, fromDate, toDate, aggType, onSuccess, onError) {
		let endPoint =
			this.baseUrl +
			`trends_excel?facility=${facility.split("/").slice(-2)[0]}&from_date=${fromDate.toISOString().split("T")[0]}&to_date=${toDate.toISOString().split("T")[0]}`;

		if (aggType) {
			endPoint = endPoint + `&time_agg=${aggType}`;
		}
		
		fetch(
            endPoint,
            {
                method: "GET",
                headers: {
                    'Accept': 'application/json',
                    'Content-Type': 'application/json',
                    'Authorization': this.getToken()
                }
            }
        ).then(
            (response) => {

                if (!response.ok) {
                    if (response.status === 401)
                        this.onUnauthorized()
                    throw response
                }
                return response.blob()
            }
        ).then(
            (blob) => {
                onSuccess(blob)
            }
        ).catch(
            () => onError()
        )
	}

	getTrendFilters(facility, onSuccess, onError) {
		let endPoint =
			this.baseUrl +
			`trend_filters/?facility=${facility.split("/").slice(-2)[0]}`;
		this.Get(endPoint, onSuccess, onError);
	}
}
